import React from 'react';
import { Typography } from '@mui/material';

const Tracking = () => {
  return <Typography variant="h5">Tracking Page</Typography>;
};

export default Tracking;
